const dict = {
  'nome': 'Nome',
  'tipo': 'Tipo',
  'data_nascimento': 'Data de Nascimento'
}
const parseEntityName = (name) => dict[name]
export default parseEntityName